// src/components/TermsOfService.js
import React from 'react';
import './TermsOfService.css';

const TermsOfService = () => {
  return (
    <div className="terms-cond">
<h1>FootyTick.com – Terms of Use</h1>

{/*<p>Effective Date: 10 February 2026</p>*/}

<p>Welcome to FootyTick.com (“we,” “our,” or “us”). These Terms of Use (“Terms”) govern your 
access to and use of our website located at www.FootyTick.com (“Site”). 
By accessing or using the Site, you agree to be bound by these Terms. If you do not 
agree to these Terms, please do not use the Site.</p>

<h1>1. About FootyTick.com</h1>
<p>FootyTick.com provides publicly available information about football (soccer) clubs that 
have won their country's top-tier football league (or its historical equivalent) and the 
date of their most recent title win. The content is for informational, non-commercial 
use only.</p>

<h1>2. Use of the Site</h1>
<p>You may use FootyTick.com only for lawful, personal, and non-commercial purposes. 
You agree not to:</p>

<p>Use the Site in any way that violates any applicable local, national, or international law or 
regulation.</p>

<p>Attempt to gain unauthorized access to any part of the Site.</p>

<p>Scrape, copy, or reproduce large portions of the Site’s data without written permission.</p>

<p>Use the Site to promote or distribute spam, viruses, or malicious content.</p>

<h1>3. Intellectual Property</h1>
<p>All original content and data compilations on the Site, including text, layout, design, 
and graphics, are the property of FootyTick.com and protected by copyright and other intellectual 
property laws, except where otherwise noted. Use of data for personal, educational, 
or journalistic use is allowed with appropriate credit. Commercial use, 
automated scraping, or republication of significant portions of the content without 
permission is prohibited.</p>

<p>Club names, logos, and league names may be registered trademarks of their respective owners.</p> 
<p>FootyTick.com does not claim ownership of these marks.</p>

<h1>4. Data Accuracy and Disclaimer</h1>
<p>We strive to provide accurate and up-to-date information. However, we do not guarantee the 
completeness, accuracy, or reliability of the data presented. Historical records can vary by 
source, and updates may not reflect real-time changes. FootyTick.com is an independent site 
and is not affiliated with FIFA, national football federations, or any football clubs.</p>

<p>Your use of the Site is at your own risk. The Site and all content are provided “as is” without 
warranty of any kind.</p>

<h1>5. Links to Other Sites</h1>
<p>FootyTick.com may contain links to external websites. We are not responsible for the content, 
policies, or practices of any third-party websites.</p>

<h1>6. Modifications to the Terms or Site</h1>
<p>We may update these Terms from time to time at our discretion. Continued use of the Site 
following the posting of any changes constitutes your acceptance of the new Terms. 
We also reserve the right to modify, suspend, or discontinue the Site (or any part of it) 
at any time without notice.</p>

<h1>7. Limitation of Liability</h1>
<p>To the fullest extent permitted by law, FootyTick.com shall not be liable for any indirect, 
incidental, or consequential damages resulting from the use of or inability to use the Site.</p>

<h1>8. Governing Law</h1>
<p>These Terms are governed by and construed in accordance with the laws of the jurisdiction 
in which the Site is operated, without regard to its conflict of law provisions.</p>

<h1>9. Contact Us</h1>
<p>For questions, concerns, or requests related to these Terms, please contact:</p>

<p>📧 Email: contact@footytick.com</p>

<p>Thank you for using FootyTick.com!</p>

      
    </div>
  );
};

export default TermsOfService;
